<template>
    <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>
    <div class="text-operations"></div>
    <div class="form-section">
        <h3>Generación de papeleta por cliente</h3>
        <img src="@/assets/filtros.png">
    </div>
    <div class="form-container">
        <div class="form-section">
            <div class="form-group-filters">
                <label>Seleccione la fecha de inicio</label>
                <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
                <label>Seleccione la fecha final</label>
                <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
            </div>
        </div>
        <div class="form-section">
            <div class="form-group-filters" style="position: relative;">
            <!-- Input Field -->
                <label for="client_name">Cliente</label>
                <input
                    type="text"
                    id="client_name"
                    v-model="clientName"
                    placeholder="Ingrese el cliente a buscar"
                    @input="filterClients"
                    autocomplete="off"
                />
                <!-- Suggestions List -->
                <ul v-if="filteredClients.length" class="suggestions-list">
                    <li
                        v-for="(client, index) in filteredClients"
                        :key="index"
                        @click="selectClient(client)"
                    >
                        {{ client.client_ident + ' - ' + client.client_name }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-section">
            <div class="form-group-filters">
                <label for="note_number_start">Número de Orden</label>
                <input type="text" id="note_number_start" v-model="noteNumberStart" placeholder="Ingrese el número de orden a buscar" />
            </div>
            <div class="form-group-filters">
                <label for="note_number_end">al</label>
                <input type="text" id="note_number_end" v-model="noteNumberEnd" placeholder="Ingrese el número de orden a buscar" />
            </div>
        </div>
        <div class="form-section">
            <div class="form-input-group">
                <label for="sucursal">Sucursal: </label>
                <select class="state-dropdown" id="sucursal" v-model="sucursal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
                    <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="form-container">
        <div class="form-section">
            <div class="form-group-filters">
                <label for="operator_id">Operador</label>
                <input type="text" id="operator_id" v-model="operatorId" placeholder="Ingrese el ID del operador a buscar" />
            </div>
        </div>
        <div class="form-section">
            <div class="form-group-filters">
                <label for="unit_id">Unidad</label>
                <input type="text" id="unit_id" v-model="unitId" placeholder="Ingrese el ID del unidad a buscar" />
            </div>
        </div>
        <div class="form-section">
            <div class="form-group-filters">
                <label for="type">Tipo de servicio</label>
                <select id="type" v-model="type" class="form-select">
                    <option value="" disabled selected>Seleccione un tipo de servicio</option>
                    <option value="Asistencia víal">Remolque</option>
                    <option value="Auxilio víal">Auxilio vial</option>
                    <option value="Lote">Lote</option>
                    <option value="Montacargas">Montacargas</option>
                    <option value="Industrial">Industrial</option>
                </select>
            </div>
        </div>
    </div>
    <button type="submit" class="btn-submit-save" @click="generateReport" :disabled="isGeneratingReport">
      {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
    </button>
</template>

<style>
.nav-bar-operations {
    position: absolute; 
    top: 0;
    left: 0;
    width: 100%; 
    height: 10vh; 
    background-color: #FFC434;
    z-index: 1000; 
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    margin: 0;
}

.logo-button {
    position: absolute; 
    height: 90%; 
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    margin: 0;
}

.text-operations {
    margin-top: 10vh; /* Adjust this value to ensure it's below the nav bar */
    left: 0;
    width: 100%;
    height: 5vh;
    border-bottom: 1px solid black;
    background-color: #ffffff;
    z-index: 999; /* Ensure it's above other content */
    font-size: 30px;
    display: flex;
    justify-content: space-between; /* Adjust spacing between elements */
    align-items: center; /* Align items vertically */
    overflow: hidden; /* Prevent text overflow */
}

.text-operations h2 {
    font-size: inherit; /* Adjust font size as needed */
    margin: 0;
    padding: 0;
    margin-left: 2vh;
}

.form-container {
    display: flex;
    justify-content: space-between;
    margin: 5px;
}

.form-section{
    flex-basis: calc(33% - 10px); /* Ajuste para margen entre secciones */
    margin-right: 10px; /* Margen entre secciones */
    background: #fff; /* Fondo para cada sección del formulario */
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1); /* Sombra suave para resaltar secciones */
}

.form-section-images img{
    width: 100px;
    height: 100px;
}

.image-container {
    margin-top: 10vh;
    width: 100%;
    height: 200px;
}

.image-container-upload {
    margin-top: 2vh;
    margin-bottom: 3vh;
    width: 100%;
    height: 200px;
}

.form-group-filters-images{
    height: 8vh;
}

.image-container-upload img{
    width: 200px !important;
    height: 200px !important;
}

.form-section:last-child {
    margin-right: 0; /* Para que no haya margen a la derecha de la última sección */
}

h2 {
    margin-bottom: 20px; /* Espacio debajo de los títulos de sección */
}

.form-group-filters label {
    text-align: left; /* Alinea el texto de la etiqueta a la izquierda */
    font-weight: bold; /* Hace que el texto de la etiqueta sea negrita */
    display: inline-block; /* Hace que la etiqueta sea en bloque pero alinee su contenido */
    width: 400%; /* Asegura que la etiqueta ocupe todo el ancho disponible */
}

.form-section img{
    width: 40px;
    height: 40px;
}

.form-group-filters input{
    width: 100%;
}

.checkbox-group {
    display: flex;
    justify-content: flex-start; 
    gap: 5px; 
    font-weight: bold;
}

.checkbox-group input{
    margin-bottom: 1vh;
}

.table-container {
    flex-grow: 1;
    overflow-x: auto;
    margin-top: 0;
    padding: 1vh;
}

.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.6em; 
}

.table th, .table td {
    border-left: none;
    border-right: none;
    padding: 5px; 
    text-align: left;
}

.table tbody tr:first-child td {
    border-top: none;
}

.table tbody tr:hover td {
    background-color: #bdbdbd;
    color: rgb(0, 0, 0);
}

.table tbody tr:last-child td {
    border-bottom: none;
}

.table thead input {
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    margin: 0;
    border-radius: 5px;
    border-width: 1px;
}

.table th{
    border-left: none;
    border-right: none;
    padding: 10px;
    text-align: left
}

.table td {
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis; 
}

.pagination-container {
    justify-content: center;
    align-items: center;
    margin-top: 2vh;
    margin-bottom: 2vh;
}

.pagination-container button {
    padding: 5px 10px;
    border: 1px solid #000;
    background-color: #fff;
    cursor: pointer;
    margin: 0 10px;
    background-color: transparent; 
    border: none; 
}

.pagination-container button:disabled {
    color: #ccc;
    cursor: not-allowed;
}

.pagination-container span {
    padding: 5px 10px;
    margin: 0 5px;
    cursor: pointer;
}

.pagination-container span.active {
    background-color: #FFC434;
}

.pagination-container button img {
    width: 25px; 
    height: auto; 
}
</style>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading'; // Import SweetAlert2
import Fuse from 'fuse.js'

export default {
    data() {
        return {
            startDate: '',
            endDate: '',
            clientName: '',
            noteNumberStart: '',
            noteNumberEnd: '',
            sucursal: '',
            operatorId: '',
            unitId: '',
            type: '',
            clientIdent: '',
            clients: [],
            filteredClients: [],
            fuse: '',
            // fileNumber: '',
            // clerk: '',
            blockEdit: false, // Set to true or false based on your requirements
            isGeneratingReport: false,
        };
    },

    computed: {
        effectiveEndDate() {
            return this.endDate || this.startDate; // Use startDate if endDate is empty
        },
    },

    methods: {
        async fetchClients() {
            try {
                const apiDirectory = process.env.API_DIRECTORY;
                const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
                this.clients = response.data;
                this.initializeFuse(); // Initialize Fuse.js with data
            } catch (error) {
                console.error('Error fetching clients:', error);
            }
        },
        initializeFuse() {
            const options = {
                keys: ['client_name'], // The key to search
                threshold: 0.3, // Adjust for typo tolerance (lower = stricter)
                ignoreLocation: true, // Ignore position of matches
                includeScore: false, // Do not include match scores
            };
            this.fuse = new Fuse(this.clients, options);
        },
        filterClients() {
            const searchTerm = this.clientName.toLowerCase().trim();

            if (searchTerm === '') {
                this.filteredClients = [];
                this.highlightedIndex = -1;
                return;
            }

            this.filteredClients = this.clients.filter(client => {
                return (
                    client.client_name.toLowerCase().includes(searchTerm) ||
                    client.client_ident.toLowerCase().includes(searchTerm)
                );
            });

            this.highlightedIndex = -1;
        },  
        selectClient(client) {
            this.clientName = client.client_name; // Update input field
            this.clientIdent = client.client_ident;
            this.filteredClients = []; // Clear suggestions
        },
        formatToDatetime(date, time) {
            if (!date) {
                return '';
            }
            return `${date}T${time}`
        },
        backMainPanel() {
            window.location.href = '/main-panel';
        },
        validateNoteNumbers() {
            // Case 1: Start has value but end is empty
            if (this.noteNumberStart !== '' && this.noteNumberEnd === '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Error de validación',
                    text: 'Debe ingresar un número de orden final cuando ingresa un número inicial',
                });
                return false;
            }
            
            // Case 2: Start is empty but end has value
            if (this.noteNumberStart === '' && this.noteNumberEnd !== '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Error de validación',
                    text: 'No puede ingresar un número de orden final sin un número inicial',
                });
                return false;
            }
            
            // Case 3: Both have values - validate end >= start
            if (this.noteNumberStart !== '' && this.noteNumberEnd !== '') {
                const startNum = parseInt(this.noteNumberStart);
                const endNum = parseInt(this.noteNumberEnd);
                
                if (endNum < startNum) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de validación',
                        text: 'El número de orden final debe ser mayor o igual al número de orden inicial',
                    });
                    return false;
                }
            }
            
            // Case 4: Both are empty - valid
            return true;
        },
        async generateReport() {
            if (this.isGeneratingReport) {
                return;
            }
            if (!this.validateNoteNumbers()) {
                return;
            }
            const payload = {
                start_date: this.formatToDatetime(this.startDate, '00:00'),
                end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
                client_name: this.clientName || "",
                note_number_start: this.noteNumberStart,
                note_number_end: this.noteNumberEnd,
                sucursal: this.sucursal,
                operator_id: this.operatorId,
                unit_id: this.unitId,
                type: this.type,
                client_ident: this.clientName === "" ? "" : this.clientIdent,
                // file_number: this.fileNumber,
                // clerk: this.clerk,
            };

            this.isGeneratingReport = true;
            showReportLoading();

            try {
                // this.validateNoteNumbers();
                console.log(payload);
                const apiDirectory = process.env.API_DIRECTORY;
                // Set responseType to 'blob' to handle file download
                const response = await axios.post(`${apiDirectory}/reports/assistance-client/`, payload, {
                    responseType: 'blob', // Important for file download
                });

                // Create a URL for the blob
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'papeleta_cliente.zip'); // Set the desired file name

                // Append to the body and trigger the download
                document.body.appendChild(link);
                link.click();

                // Cleanup
                link.remove();
                window.URL.revokeObjectURL(url);

                console.log('Report generated and downloaded successfully.');
            } catch (error) {
                const errorMessage = error.response ? error.response.data.error : error.message;
                Swal.fire({
                    icon: 'error',
                    title: 'Error Generando Reporte',
                    text: errorMessage,
                });
            } finally {
                this.isGeneratingReport = false;
                hideReportLoading();
            }
        },
    },
    mounted() {
        this.fetchClients();
    }
};
</script>
